import { Outlet, createFileRoute } from "@tanstack/react-router"
import { requireProviderGroupAdmin } from "@/utils/routeGuards"

export const Route = createFileRoute("/_layout/provider")({
  component: () => <Outlet />,
  beforeLoad: requireProviderGroupAdmin(),
})
